
import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { GridStatusChip } from 'styles/elements/styleElements'
import { Deals } from '../../../../types'

interface RenderDealStatusProps {
  params: { row: GridRenderCellParams<Deals, object> }
}

const RenderDealStatusCell: React.FC<RenderDealStatusProps> = ({ params }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <GridStatusChip size="small" type={(params as any)?.value} label={(params as any)?.value} />
    </Box>
  )
}
export default RenderDealStatusCell
